import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[chatLocation]'
})
export class ChatLocationDirective {
  @Input('chatLocation') set location(value: string) {
    this.setupMap(value);
  }

  constructor(private el: ElementRef) { }

  private setupMap(messageContent: string) {
    let [lat,long] = messageContent.split(',');
  
    const mapProperties = {
        center: new google.maps.LatLng(Number(lat), Number(long)),
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false
    };

    const chatMap = new google.maps.Map(this.el.nativeElement, mapProperties);
    const marker = new google.maps.Marker({ position: mapProperties.center });
    marker.setMap(chatMap);
  }
}
